import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {useBackground} from '../../../../hooks/background-class';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {onClickHandler} from '../../../../utils/onclick';
import './index.scss';
import {Configs} from '../../../../configs';
import {useFilterSelector} from '../../../../hooks/filter-selector';
import {useOrientation} from '../../../../hooks/orientation';
import {MediaFileTag} from '../../../../store/ui/state';
import {useLocalization} from "../../../../hooks/localization";
import {useRPC} from "../../../../hooks/rpc";
import iconCancel from '../../../../assets/images/icons/alarm/cancel.png'
import iconOk from "../../../../assets/images/icons/alarm/ok.png"
import iconReturn from "../../../../assets/images/icons/alarm/return.png"

const MyButton = memo(function MyButton({icon, onClick}: { icon?: string; onClick: () => void }) {
    return (
        <div className="button" {...onClickHandler(onClick)}>
            <img src={icon} alt=""/>
        </div>
    );
});

export const BackgroundSettingsScreen = memo(function BackgroundSettingsScreen() {
    const [, changeBackground, backgroundStyle] = useBackground();
    const {t} = useLocalization();
    const orientation = useOrientation("horizontal");
    const [rpc] = useRPC();
    const backgroundList = useFilterSelector(state => state.ui.mediaFileList, media => media.type === "background" && media.tags.includes(orientation as MediaFileTag),
    [orientation]);
    const [statusModal, setStatusModal] = useState(false)
    const [imagePath, setImagePath] = useState("first")

    const deleteMedia = useCallback(() => {
        rpc.deleteMediaFile(imagePath)
            .then(() => changeBackground("first"))
            .then(() => setStatusModal(false))
            .catch(() => setStatusModal(false))
    }, [imagePath, rpc, changeBackground])

    const changeMedia = useCallback(() => {
        changeBackground(imagePath)
        setStatusModal(false)
    }, [imagePath, changeBackground])

    const button = useMemo(
        () => [
            {
                text: t("default"),
                className: "green",
                onClick: () => changeBackground("first")
            }
        ],
        [t, changeBackground]
    )

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={button}
                backUrl={"/settings/custom-menu"}
                className={"background-settings"}
                style={backgroundStyle}
            >
                <div className={"background-settings-screen"}>
                    {backgroundList.map(image => (
                        <MyButton
                            key={image.url}
                            icon={`${Configs.IMAGE_PREFIX}/media/${image.id}`}
                            onClick={() => {
                                setStatusModal(true)
                                setImagePath(image.id)
                            }}
                        />
                    ))}
                    <div className={`bg_modal_wrapper ${statusModal ? " " : " _modal-close"}`}>
                        <div className="bg_modal_box">
                            <div className="bg_modal_text">
                                <span>{"Duvar kağıdı işlemleri"}</span>
                            </div>
                            <div className="bg_modal_action">
                                <button onClick={() => setStatusModal(false)}><img src={iconReturn} alt=''/>İptal</button>
                                <button {...onClickHandler(changeMedia)}><img src={iconOk} alt=''/>Değiştir</button>
                                <button {...onClickHandler(deleteMedia)}><img src={iconCancel} alt=''/>Sil</button>
                            </div>
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
});
